import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentEmpid, selectCurrentUserManagerLevel } from '../../pages/login/authSlice';
import { ROLES } from '../../constants';
import { AssociateCAP } from '../../features/coachingAction/associateCAP/AssociateCAP';
import { TeamLeadCAP } from '../../features/coachingAction/teamLeadCAP/TeamLeadCAP';
import ManagerCAP from '../../features/coachingAction/managerCAP/ManagerCAP';

export const CoachingActionPlan = () => {
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const loggedUser = useSelector(selectCurrentEmpid);

    if (userManagerLevel && ROLES.Agents.includes(userManagerLevel)) {
        return <AssociateCAP empNo={String(loggedUser)} />;
    } else if(ROLES.Supervisor.includes(userManagerLevel)){
        return <TeamLeadCAP />;
    } else {
        return <ManagerCAP />;
    }
    // return null;
}
